import api from '../../../services/Api';
import { IAuditoriaAjusteExerciciosAnterioresResultado } from '../interfaces/IAuditoriaAjusteExerciciosAnteriores';

export const AuditoriaAjusteExerciciosAnterioresService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaAjusteExerciciosAnterioresResultado> {
    const response = await api.get<IAuditoriaAjusteExerciciosAnterioresResultado>('auditoria-ajuste-exercicios-anteriores/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoMovimentacao: '',
        movimentacoesIndevidas: [],
        contasConciliadas: [],
      }
    );
  },
};
